/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDRadiusDownLeftIcon20Regular = forwardRef('ArrowDRadiusDownLeftIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M16.5 4a6.25 6.25 0 0 1-6.25 6.25H3.91l4.22-4.22a.75.75 0 0 0-1.06-1.06L2.63 9.409a2.25 2.25 0 0 0 0 3.182l4.44 4.44a.75.75 0 0 0 1.06-1.061l-4.22-4.22h6.34A7.75 7.75 0 0 0 18 4V2.75a.75.75 0 0 0-1.5 0V4Z" })));
});
